<template>
  <el-dialog title='批量修改' :visible.sync='dialogVisible' :modal='false' width='500px'>
    <div class='content_box'>
      <a :href="type === 'SampleUsers' ? './mobanTh.xlsx' : './moban.xlsx'" target='_blank' download='批量修改地址模板.xlsx' class='color-blue'>下载修改地址模板表</a>
      <el-upload class='upload-demo' action='#' :on-change='handleChange' :file-list='fileList'> 修改表 <el-button size='small' type='primary'>选择文件</el-button>
        <!-- <div slot='tip' class='el-upload__tip'>只能上传jpg/png文件，且不超过500kb{{ type }}</div> -->
      </el-upload>
    </div>
    <span slot='footer' class='dialog-footer'>
      <el-button round @click='dialogVisible = false'>取消</el-button>
      <el-button type='primary' round @click='submit'>确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getAddressByUserId, addressSetDefault, verifyAddressFromExcel } from '@/api/crm'
import XLSX from 'xlsx'
// import hrefUrl from '@/static/moban.xlsx'
export default {
  name: 'batch-updata-address',
  data () {
    return {
      hrefUrl: '@/static/moban.xlsx',
      dialogVisible: false,
      excelVal: [], // excel有效数据
      fileList: [],
      type: ''
    }
  },
  created () {
    //   this.getAddressList()
  },
  methods: {
    readFile (file) {
      // 文件读取
      return new Promise((resolve) => {
        let reader = new FileReader()
        reader.readAsBinaryString(file) // 以二进制的方式读取
        reader.onload = (ev) => {
          resolve(ev.target.result)
        }
      })
    },
    async handleChange (ev) {
      console.log('evvvvvvv', ev)
      let file = ev.raw
      this.fileList = [{ name: file.name, url: '' }]
      if (this.lastUid === file.uid) {
        return
      }
      this.lastUid = file.uid
      if (file) {
        if (
          file.name.indexOf('.xls') !== -1 ||
          file.name.indexOf('.xlsx') !== -1
        ) {
          // 这里进行了判断，只能读取这两种类型的文件。
          let data = await this.readFile(file)
          let workbook = XLSX.read(data, { type: 'binary', cellDates: true }) // 解析二进制格式数据
          let worksheet = workbook.Sheets[workbook.SheetNames[0]] // 获取第一个Sheet
          let result = XLSX.utils.sheet_to_json(worksheet) // json数据格式
          console.log('result', result)
          let excelVal = result.filter(res => {
            if (res['收件人姓名']) {
              return res
            }
          })
          console.log('excelVal', excelVal)
          this.excelVal = excelVal.map(item => {
            // let address = item['地址（XX省/XX市/XX区县/详细地址）']
            // let content = this.getAddress(address)
            // let content = this.getArea(address)
            // console.log('content', content)
            // let isTrue
            // let res = await verifyAddressFromExcel({
            //   city: content.city,
            //   county: content.county,
            //   province: content.province
            // })
            // if (res.data.success) {
            //   isTrue = true
            // } else {
            //   isTrue = false
            // }
            return {
              name: item['文件夹名称'],
              // province: content.Province ? content.Province : '北京',
              // city: content.City,
              // county: content.Country,
              fullAddress: item['地址（XX省/XX市/XX区县/详细地址）'],
              person: item['收件人姓名'],
              phone: item['收件人联系方式'],
              completeAddress: item['地址（XX省/XX市/XX区县/详细地址）']
              // isTrue: isTrue
            }
          })
          // Promise.all(excelVals).then(res => {
          //   console.log('res', res)
          //   this.excelVal = res
          // })
        }
      }
    },
    show (type) {
      this.type = type
      this.excelVal = []
      this.fileList = []
      this.dialogVisible = true
    },
    hide () {
      this.isShow = false
    },
    submit () {
      this.$emit('filechange', this.excelVal)
      this.dialogVisible = false
    },
    // 过滤特殊字符
    stripscript (s) {
      let pattern = new RegExp("[`·~!@#$^&*()=|{}':;',\\[\\]./?~！@#￥……&*（）——|{}【】‘；：”“'。，、？-]")
      let rs = ''
      for (let i = 0; i < s.length; i++) {
        rs = rs + s.substr(i, 1).replace(pattern, '')
      }
      return rs
    },
    // var str = "湖北省武汉市江夏区文化大道110号";
    // var str ="内蒙古自治区乌兰浩特市二区"
    // var str = "重庆市渝中区中兴路"
    // var str = "湖北省黄石市阳新县"
    // var str ="湖北省宜昌市长阳土家族自治县"
    // var str = "重庆市秀山土家族苗族自治县武陵南路武陵广场"

    // console.log(that.getArea(str));
    // 省市区截取
    getArea (str) {
      let area = {}
      let index11 = 0
      let index1 = str.indexOf('省')
      if (index1 === -1) {
        index11 = str.indexOf('自治区')
        if (index11 !== -1) {
          area.Province = str.substring(0, index11 + 3)
        } else {
          area.Province = str.substring(0, 0)
        }
      } else {
        area.Province = str.substring(0, index1 + 1)
      }

      let index2 = str.indexOf('市')
      if (index11 === -1) {
        area.City = str.substring(index11 + 1, index2 + 1)
      } else {
        if (index11 === 0) {
          area.City = str.substring(index1 + 1, index2 + 1)
        } else {
          area.City = str.substring(index11 + 3, index2 + 1)
        }
      }

      let index3 = str.lastIndexOf('区')
      if (index3 === -1) {
        index3 = str.indexOf('县')
        area.Country = str.substring(index2 + 1, index3 + 1)
      } else {
        area.Country = str.substring(index2 + 1, index3 + 1)
      }
      area.fullAddress = str.slice(str.indexOf('区') + 1, str.length + 1)
      return area
    }
    // 分割省市区
    // getAddress (address) {
    //   let content = {
    //     province: '',
    //     city: '',
    //     county: '',
    //     fullAddress: ''
    //   }
    //   // 省
    //   let province = address.slice(0, address.indexOf('省') + 1)
    //   //  特别行政区
    //   let tb = address.slice(0, address.indexOf('区') + 1)
    //   let specialRegion = tb.slice(tb.indexOf('区', 8) + 1)
    //   // 自治区
    //   let autonomousRegion = address.slice(0, address.indexOf('区') + 1)
    //   // 直辖市
    //   let municipality = address.slice(0, address.indexOf('市') + 1)
    //   // 省市
    //   let city = address.slice(address.indexOf('省') + 1, address.indexOf(
    //     '市') + 1)
    //   // 省自治州
    //   let State = ''
    //   if (!city) {
    //     State = address.slice(address.indexOf('省') + 1, address.indexOf('州') +
    //       1)
    //     console.log('省自治州:', State)
    //   }
    //   // 省县（台湾）
    //   let provinceCounty = address.slice(address.indexOf('省') + 1, address
    //     .indexOf('县') + 1)
    //   // 区市
    //   let areaCity = address.slice(address.indexOf('区') + 1, address.indexOf(
    //     '市') + 1)
    //   // 市区
    //   let CityArea = address.slice(address.indexOf('市', 4) + 1, address
    //     .lastIndexOf('区') + 1)
    //   // 区区
    //   let areaArea = ''
    //   if (specialRegion) {
    //     let d = CityArea.slice(CityArea.indexOf('区') + 1, CityArea.lastIndexOf('区') + 1)
    //     areaArea = d.slice(d.indexOf('区') + 1, d.lastIndexOf('区') + 1)
    //   } else {
    //     areaArea = address.slice(address.indexOf('区') + 1, address.lastIndexOf('区') + 1)
    //   }
    //   // 区盟
    //   let areaAlliance = address.slice(address.indexOf('区') + 1, address
    //     .lastIndexOf('盟') + 1)
    //   // 区市旗  自治区（内蒙古）
    //   let areaFlag = address.slice(address.indexOf('市') + 1, address.indexOf(
    //     '旗') + 1)
    //   // 区盟市
    //   let AllianceArea = address.slice(address.indexOf('盟') + 1, address
    //     .indexOf('市') + 1)
    //   // 省市区
    //   let area = ''
    //   // 省市县
    //   let county = ''
    //   // 省自治州市
    //   let autonomousPrefecture = ''
    //   // 省自治州县
    //   let autonomousCounty = ''
    //   if (!State) { // 当存在自治州时 不执行
    //     // 省市区
    //     area = address.slice(address.indexOf('市') + 1, address.indexOf('区') + 1)
    //     // 省市县
    //     county = address.slice(address.indexOf('市') + 1, address.indexOf('县') + 1)
    //   } else {
    //     // 省自治州市
    //     autonomousPrefecture = address.slice(address.indexOf('州') + 1, address.indexOf('市') + 1)
    //     // 省自治州县
    //     autonomousCounty = address.slice(address.indexOf('州') + 1, address.indexOf('县') + 1)
    //   }
    //   // 省市市
    //   let countyCounty = address.slice(address.indexOf('市') + 1, address
    //     .lastIndexOf('市') + 1)
    //   // 赋值给data中的content
    //   content.province = province || (municipality === '北京市' ||
    //     municipality === '重庆市' || municipality === '天津市' || municipality === '上海市' ? municipality : autonomousRegion)
    //   console.log(content.province, 'content.province')
    //   let a = autonomousRegion === '广西壮族自治区' || autonomousRegion === '内蒙古自治区' || autonomousRegion === '宁夏回族自治区' || autonomousRegion === '新疆维吾尔自治区' || autonomousRegion === '西藏自治区'
    //   let b = specialRegion === '香港特别行政区' || specialRegion === '澳门特别行政区'
    //   // 市、区、盟、州
    //   content.city = province === '台湾省' ? '台湾' : a ? areaCity : areaAlliance || (b ? specialRegion : State || (city || (municipality || areaArea)))
    //   console.log(content.city, 'content.city')
    //   // 区、县、市、旗
    //   content.county = province === '台湾省' ? provinceCounty || city : b ? areaArea : areaAlliance ? AllianceArea : areaFlag || (autonomousCounty || (autonomousPrefecture || (CityArea || (county || (countyCounty || area)))))
    //   console.log(content.county, 'content.county')
    //   content.fullAddress = address.slice(address.indexOf('区') + 1, address.length + 1)
    //   return content
    // }
  }
}
</script>

<style scoped lang='less'>
@deep: ~'>>>';

.content_box {
  max-height: 355px;
  overflow-y: auto;

  .upload-demo {
    margin-top: 30px;
  }
}

.choosed {
  border: 2px solid #808080;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.16);
}

.dialog-footer {
  span {
    float: left;
    margin-left: 20px;
    font-size: 12px;
    font-family: Source Han Sans CN, Source Han Sans CN-Light;
    font-weight: 300;
    text-align: left;
    color: #2e7cd4;
    cursor: pointer;
  }
}
</style>
